import QrIcon from './Icons/QrIcon'
import SupportIcon from './Icons/SupportIcon'
import TranRoutesIcon from './Icons/TranRoutesIcon'

export const navItems = [
  {
    url: '/qr',
    Icon: QrIcon,
    title: 'QR-квитки',
  },
  {
    url: '/tran_routes',
    Icon: TranRoutesIcon,
    title: 'Маршрути',
  },
  {
    url: '/support',
    Icon: SupportIcon,
    title: 'Підтримка користувачів',
    shortTitle: 'Підтримка',
  },
]
